
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auxilia/[slug]",
      function () {
        return require("private-next-pages/auxilia/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auxilia/[slug]"])
      });
    }
  